import ActionUtility from "../ActionUtility";

export default class AdidAction {
  static UPDATE_ADID_STATE = "AdidAction.UPDATE_ADID_STATE";

  static CREATE_ADID_REQUEST = "AdidAction.CREATE_ADID_REQUEST";
  static CREATE_ADID_TARGET = "AdidAction.CREATE_ADID_TARGET";
  static CREATE_POLYGON_TARGET = "AdidAction.CREATE_POLYGON_TARGET";

  static GET_ADID_REQUESTS = "AdidAction.GET_ADID_REQUESTS";
  static GET_ADID_TARGET = "AdidAction.GET_ADID_TARGET";


  static updateAdidState(action) {
    return ActionUtility.createAction(AdidAction.UPDATE_ADID_STATE, action);
  }

  static createAdidRequest(caseId, msisdn, callback) {
    return ActionUtility.createAction(AdidAction.CREATE_ADID_REQUEST, {caseId, msisdn, callback});
  }

  static createAdidTarget(caseId, createData, callback) {
    return ActionUtility.createAction(AdidAction.CREATE_ADID_TARGET, {caseId, createData, callback});
  }

  static createPolygonTarget(caseId, createData, callback) {
    return ActionUtility.createAction(AdidAction.CREATE_POLYGON_TARGET, {caseId, createData, callback});
  }

  static getAdidRequests(caseId, filters, callback) {
    return ActionUtility.createAction(AdidAction.GET_ADID_REQUESTS, {caseId, filters, callback});
  }

  static getAdidTarget(id, callback) {
    return ActionUtility.createAction(AdidAction.GET_ADID_TARGET, {id, callback});
  }


}
